import { DragHandleOutlined } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  styled,
  Typography,
} from '@mui/material';

export const StyledWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  align-items: start;
  border-bottom: 1px solid ${theme.palette.secondary.lighter};
  min-height: 50px;
  > svg {
    margin-top: 12px;
  }

  &.dragged {
    z-index: 1200; // to override Mui drawer of 1200
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2); 
  }
`,
);

export const StyledAccordion = styled(Accordion)`
  margin: 0;
  justify-content: space-between;
  width: 100%;
`;

export const StyledAccordionItem = styled(AccordionSummary)`
  margin: 7px 0 0 0;
  padding-left: 0;
  min-height: auto;
  height: 35px;
  padding-right: 0;
  &.Mui-expanded {
    min-height: auto;
    margin: 7px 0 0 0;
  }

  & .MuiAccordionSummary-content {
    align-items: center;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  > label {
    & span:first-child {
      padding-right: 7px;
    }
  }

  padding-left: 10px;
`;

export const StyledOptionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const StyledInfoWrapper = styled(Box)`
  margin-top: 20px;
`;

export const StyledCheckBoxWrapper = styled(Box)`
  margin-left: 30px;
  display: flex;
  flex-direction: column;
`;

export const StyledUnsortableWrapper = styled(Box)`
  margin-left: 30px;
`;

export const BoldTypography = styled(Typography)`
  font-weight: 400;
  word-break: break-all;
`;

export const StyledFlavourWrapper = styled(Box)`
  display: flex;
  align-items: center;

  &.dragged {
    z-index: 1200; // to override Mui drawer of 1200
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const StyledShowFlavorCount = styled(Typography)(
  ({ theme }) => `
  margin-top: 3px;
  align-items: center;
  display: flex;
  margin-left: 10px;
  width: 17px;
  height: 18px;
  background: ${theme.palette.primary.main};
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 12px;
`,
);

export const ColouredDragIcon = styled(DragHandleOutlined)(
  ({ theme }) => `
  color: ${theme.palette.secondary.main};
`,
);

export const StyledFlavourNameWrapper = styled('div')`
  display: flex;
`;

export const StyledFlavourName = styled(Typography)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline;
  max-width: 185px;
  margin-right: 13px;
`;

export const StyledProductCode = styled(Typography)(
  ({ theme }) => `
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${theme.palette.brand.charcoal};
  `,
);

export const FlexGrid = styled(Grid)`
  display: flex;
`;
